// количество статей в виджете "Телевизор"
// используется для offset при запросе home-posts
// на главной и в архивах "Все статьи"
export const TV_COUNT_ARTICLES = 4;

// количество статей на странице в архиве
export const ARCHIVES_ARTICLES_COUNT_ON_PAGE = 30;

// Максимальная длинна выделения для сообщения об опечатке
export const MISSPRINT_SELECTION_MAX_LENGTH = 200;

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

// Стандратные значения для плеера viqeo
export const DEFAULT_VIQEO_PLAYER_ID = 4929;
export const DEFAULT_VIQEO_PROFILE_ID = 17220;

// Октябрьский логотип (розовая лента), с 1 ноября 2026 (МСК) возвращается обычный
const OCTOBER_2026_LOGO_END = Date.parse('2026-11-01T00:00:00+03:00');
export const isOctober2026Logo = (): boolean => Date.now() < OCTOBER_2026_LOGO_END;
